<template>
  <div>
    <div class="input-group">
      <span class="input-group-addon">
        +7
      </span>
      <input
        v-mask="'(###) ###-##-##'"
        v-model="phone"
        :id="inputId"
        autocomplete="off"
        class="form-control"
        @input="$emit('input', formattedPhone)"/>
    </div>
    <span
      v-if="error"
      :class="advancedErrorClass"
      class="small text-danger">
      {{ errorText }}
    </span>
  </div>
</template>

<script>
import { VueMaskDirective } from 'v-mask'

export default {
  name: 'ApInputPhone',
  props: {
    value: {
      type: String,
      default: ''
    },
    advancedErrorClass: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: 'Введите правильный номер телефона'
    },
    inputId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      phone: this.value
    }
  },
  computed: {
    formattedPhone () {
      return this.phone.replace(/\D+/g, '')
    }
  },
  directive: VueMaskDirective
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ApInputPhone.vue?f7688000